import React from "react";
import "../styles/ArticleHero.css";

const ArticleHero = ({ title, description, backgroundImage }) => {
  return (
    <section
      className="article-hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="article-hero-overlay"></div>
      <div className="article-hero-content">
        <h1 className="article-hero-title">{title}</h1>
        <p className="article-hero-description">{description}</p>
      </div>
    </section>
  );
};

export default ArticleHero;
